import { Card } from "@/components/ui/card";
import { MapPin, Trophy, GraduationCap } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export const About = () => {
  const { t } = useLanguage();

  const journey = [
    { location: "Italia", description: t("about", "journeyItalia") },
    { location: "Canadá", description: t("about", "journeyCanada") },
    { location: "Ibiza", description: t("about", "journeyIbiza") },
    { location: "Madrid", description: t("about", "journeyMadrid") },
    { location: "Suiza", description: t("about", "journeySuiza") },
    { location: "Valencia", description: t("about", "journeyValencia") },
  ];

  return (
    <section id="sobre-mi" className="py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
              {t("about", "title")}
            </h2>
            <div className="w-24 h-1 bg-gold mx-auto"></div>
          </div>

          <div className="prose prose-lg max-w-none mb-12 text-foreground/80">
            <p className="text-lg leading-relaxed mb-6">{t("about", "bio1")}</p>
            <p className="text-lg leading-relaxed mb-6">{t("about", "bio2")}</p>
            <p className="text-lg leading-relaxed mb-6">{t("about", "bio3")}</p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mb-12">
            <Card className="p-6 text-center hover:shadow-lg transition-all duration-300">
              <Trophy className="w-12 h-12 text-gold mx-auto mb-4" />
              <h3 className="font-bold text-xl mb-2">{t("about", "achievement1Title")}</h3>
              <p className="text-muted-foreground">{t("about", "achievement1Desc")}</p>
            </Card>
            <Card className="p-6 text-center hover:shadow-lg transition-all duration-300">
              <Trophy className="w-12 h-12 text-gold mx-auto mb-4" />
              <h3 className="font-bold text-xl mb-2">{t("about", "achievement2Title")}</h3>
              <p className="text-muted-foreground">{t("about", "achievement2Desc")}</p>
            </Card>
            <Card className="p-6 text-center hover:shadow-lg transition-all duration-300">
              <Trophy className="w-12 h-12 text-gold mx-auto mb-4" />
              <h3 className="font-bold text-xl mb-2">{t("about", "achievement3Title")}</h3>
              <p className="text-muted-foreground">{t("about", "achievement3Desc")}</p>
            </Card>
          </div>

          <div className="bg-card rounded-lg p-8 border border-border">
            <h3 className="text-2xl font-bold mb-6 flex items-center gap-3">
              <MapPin className="text-gold" />
              {t("about", "recorrido")}
            </h3>
            <div className="space-y-4">
              {journey.map((stop, index) => (
                <div key={index} className="flex items-start gap-4 group">
                  <div className="w-3 h-3 rounded-full bg-gold mt-2 group-hover:scale-150 transition-transform"></div>
                  <div>
                    <h4 className="font-bold text-lg text-foreground">{stop.location}</h4>
                    <p className="text-muted-foreground">{stop.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-12 text-center">
            <p className="text-lg text-foreground/80 italic max-w-3xl mx-auto">
              {t("about", "quote")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
